module.exports = __webpack_public_path__ + "media/icons/card-icon-5d531a58.png";